import { render } from "./NewHome.vue?vue&type=template&id=c61c7b1c&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"

import "./NewHome.vue?vue&type=style&index=0&id=c61c7b1c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61c7b1c"]])

export default __exports__